module.exports = __webpack_public_path__ + "static/media/63-iveco.8ef7d315.jpg";